module.exports = __webpack_public_path__ + "static/media/si.181cb6b0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/si.svg
// module id = 2207
// module chunks = 0